<template>
  <search-from
    :fields="fields"
    :pagination="pagination"
    @click="onSearch"
  ></search-from>
</template>

<script>
  import {parseEnum} from "../../shared/utils";
  import {Donation} from "../../models/Donation";
  import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
  import SearchFrom from "../base/SearchForm";
  import {SearchField} from "../../services/SearchField";
  import {PaginationMeta} from "../../models/PaginationMeta";

  const DonationRepo = RepositoryFactory.get('donation')
  const CampaignRepo = RepositoryFactory.get('campaign')

  export default {
    name: 'donation-search-form',
    components: {
      SearchFrom,
    },
    data() {
      return {
        fields: [
          new SearchField()
            .setKey('status')
            .setDescription('Donation Status')
            .setLabel('Status')
            .setType(SearchField.FIELD_TYPES.FIELD_SELECT)
            .setValues(parseEnum(Donation.STATUS))
          ,
          new SearchField()
            .setKey('campaign')
            .setDescription('Campaign Filter')
            .setLabel('Campaign')
            .setType(SearchField.FIELD_TYPES.FIELD_SELECT)
        ],
      }
    },
    props: {
      pagination: Object,
      default: new PaginationMeta(),
    },
    methods: {
      onSearch(params) {
        this.$emit('click', params)
        DonationRepo
          .searchDonations(params)
          .then(
            response => (
              this.$emit('change', response.data)
            )
          )
      }
    },
    mounted() {
      let campaigns = []
      CampaignRepo
      .searchCampaigns({})
      .then(
        response => (
          response.data.data.forEach(
            field => campaigns.push(
              {
                text: field.name,
                value: field.id,
              }
            )
          ),
          this.fields[1].values = campaigns
        )
      )
    }
  }
</script>
